import React from "react";
import { Link } from "react-router-dom";
import * as Lucide from "lucide-react";
import { SERVICES } from "@/lib/constants";

export const ServicesGrid = ({ compact = false }) => {
    return (
        <section data-testid="services-grid" className="bg-[#F3F1EA]">
            <div className="container-prose py-24">
                {!compact && (
                    <div className="max-w-2xl mb-16">
                        <div className="overline">Our services</div>
                        <h2 className="mt-4 font-serif text-4xl sm:text-5xl tracking-tight leading-[1.05] text-[#1A362B] font-medium">
                            Finance for every stage of your journey.
                        </h2>
                        <div className="divider-thin my-6" />
                        <p className="text-base sm:text-lg text-[#1C1C1C]/75 leading-relaxed">
                            From your first home to your next investment property — we craft loan strategies
                            that grow with your life.
                        </p>
                    </div>
                )}

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
                    {SERVICES.map((s, i) => {
                        const Icon = Lucide[s.icon] || Lucide.CircleDot;
                        return (
                            <Link
                                key={s.slug}
                                to={`/${s.slug === "self-employed" ? "self-employed-loans" : s.slug === "car-loans" ? "car-asset-finance" : s.slug}`}
                                data-testid={`service-card-${s.slug}`}
                                className="group relative bg-white border border-border p-8 rounded-sm hover:-translate-y-1 hover:shadow-xl transition-all duration-300 flex flex-col"
                            >
                                <div className="w-12 h-12 rounded-sm bg-[#1A362B]/5 grid place-items-center text-[#1A362B] group-hover:bg-[#1A362B] group-hover:text-white transition-colors">
                                    <Icon className="w-5 h-5" />
                                </div>
                                <h3 className="mt-6 font-serif text-2xl text-[#1A362B] tracking-tight">{s.title}</h3>
                                <p className="mt-3 text-sm text-[#1C1C1C]/70 leading-relaxed flex-1">{s.desc}</p>
                                <div className="mt-6 inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase font-semibold text-[#C69C6D]">
                                    Learn more <Lucide.ArrowRight className="w-3.5 h-3.5" />
                                </div>
                                <span className="absolute top-6 right-6 font-serif text-xs text-[#1A362B]/30">0{i + 1}</span>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default ServicesGrid;
